import React from 'react';
import { Modal, Loading, Box } from '@zen-common/components-base';

export default function LoadingModal() {
  return (
    <Modal>
      <Box
        textAlign="center"
        width="200px"
        height="100px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box display="flex">
          <Box mr="sm">Deleting storage...</Box>
          <Loading />
        </Box>
      </Box>
    </Modal>
  );
}
